// Add spinner to a specific div
export default function(el) {

  // Set a spinner to indicate table loading
  let spinner = '<div class="d-flex justify-content-center spinner-container">';
  spinner += '<div class="spinner-border text-primary" role="status">';
  spinner += '<span class="sr-only">Loading...</span></div></div>';
  return $(el).append(spinner);

}